import React from 'react';
import { Card, theme } from 'antd';
import type { CardProps } from 'antd';
import { getZoneStyle, type ControlTowerZone } from './controlTowerTheme';

export interface ControlTowerSectionCardProps extends Omit<CardProps, 'id'> {
  zone: ControlTowerZone;
  sectionId?: string;
}

export const ControlTowerSectionCard: React.FC<ControlTowerSectionCardProps> = ({
  zone,
  sectionId,
  title,
  children,
  style,
  styles,
  ...rest
}) => {
  const { token } = theme.useToken();
  const zoneStyle = getZoneStyle(token, zone);

  return (
    <Card
      id={sectionId}
      size="small"
      title={title}
      style={{ ...zoneStyle.cardStyle, ...style }}
      styles={{
        header: { ...zoneStyle.headerStyle, ...styles?.header },
        body: { ...zoneStyle.bodyStyle, ...styles?.body },
      }}
      {...rest}
    >
      {children}
    </Card>
  );
};
